<div class="report-table-container">
  <mat-form-field appearance="outline" class="filter-input">
    <mat-label>Search</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Search in results...">
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>

  <div class="table-wrapper">
    <table mat-table [dataSource]="dataSource" matSort reportSort
           [reportSortDataSource]="dataSource"
           [reportSortHeaders]="reportData.headers"
           class="report-table">
      <ng-container *ngFor="let header of reportData.headers" [matColumnDef]="header.field">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ header.label }}</th>
        <td mat-cell *matCellDef="let row" [class]="'cell-format-' + row[header.field].color">
          <ng-container *ngIf="header.type === 'string'">
            {{ row[header.field].value }}
          </ng-container>
          <ng-container *ngIf="header.type === 'date'">
            {{ row[header.field].value }}
          </ng-container>
          <ng-container *ngIf="header.type === 'number'">
            {{ row[header.field].value }}
          </ng-container>
          <ng-container *ngIf="header.type === 'percentage'">
            {{ row[header.field].value | percent }}
          </ng-container>
          <ng-container *ngIf="header.type === 'dollar'">
            {{ row[header.field].value | currency:'USD':'symbol':'1.2-2' }}
          </ng-container>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="getHeaderFields()"></tr>
      <tr mat-row *matRowDef="let row; columns: getHeaderFields()"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="reportData.headers.length">
          No data matching the filter
        </td>
      </tr>
    </table>
  </div>

  <mat-paginator
    [pageSizeOptions]="[10, 25, 50, 100]"
    showFirstLastButtons
    aria-label="Select page of report data">
  </mat-paginator>
</div>
